<template>
    <div v-if="isPc" class="module-title">
        <div class="rectangle-68" :class="{ 'rectangle-68-first': isFirst }"></div>
        <span class="brand-dynamic" :class="{ 'brand-dynamic-first': isFirst }">{{ title }}</span>
    </div>
    <div v-else class="mob-module-title">
        <div class="left-decoration-container">
            <div :class="['line-left', {'line-left-honor': isHonor}]"></div>
            <div :class="['diamond', {'diamond-honor': isHonor}]"></div>
        </div>
        <div class="title-text-container">
            <span class="title-text">{{ title.split(' ')[0] }}</span>
            <span class="title-text">{{ title.split(' ')[1] }}</span>
        </div>
        <div class="right-decoration-container">
            <div :class="['diamond', {'diamond-honor': isHonor}]"></div>
            <div :class="['line-right', {'line-right-honor': isHonor}]"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModuleHead',
    props: {
        isHonor: {
            type: Boolean,
            default: false
        },
        isPc: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        isFirst: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // 删除了原来的图片URL数据
        };
    }
};
</script>

<style scoped>
.module-title {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
}

.rectangle-68 {
    width: 4px;
    height: 20px;
    background: #4d83ff;
    margin-right: 10px;
}

.rectangle-68-first {
    margin-top: 80px;
}

.brand-dynamic {
    color: #2f2f2f;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-weight: 600;
}

.brand-dynamic-first {
    margin-top: 80px;
}

.mob-module-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.left-decoration-container, .right-decoration-container {
    display: flex;
    align-items: center;
    /* width: 50px; 给装饰容器固定宽度 */
}

.left-decoration-container {
    margin-right: 10px;
}

.right-decoration-container {
    margin-left: 10px;
}

.line-left, .line-right {
    width: 45.6px;
    height: 1px;
    /* background-color: #4D83FF; */
}

.line-left {
    background: linear-gradient(to left, #4D83FF 0%, rgba(77, 131, 255, 0.00) 100%);
}

.line-right {
    background: linear-gradient(90deg, #4D83FF 0%, rgba(77, 131, 255, 0.00) 100%);
}

.diamond {
    width: 3.7px;
    height: 3.7px;
    background-color: #4D83FF;
    transform: rotate(45deg);
}

.line-left-honor {
    background: linear-gradient(to left, #6C4E36 0%, rgba(255, 107, 107, 0.00) 100%);
}

.line-right-honor {
    background: linear-gradient(90deg, #6C4E36 0%, rgba(255, 107, 107, 0.00) 100%);
}

.diamond-honor {
    background-color: #6C4E36;
}

.title-text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.title-text {
    color: #2f2f2f;
    font-family: 'PingFang SC';
    font-size: 20px;
    font-weight: 600;
    line-height: normal;
}
</style>